var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addAddress"},[_c('van-address-edit',{attrs:{"show-delete":"true","area-list":this.areaList,"address-info":this.$store.state.targetAddress,"show-set-default":"","show-search-result":""},on:{"save":_vm.onSave,"delete":_vm.onDelete}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de3bce50","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/address/addAddress.vue
// module id = null
// module chunks = 